import { CHART_SERIES_COLORS } from "@/constants/chartColors";

/** Multi-series palette — 10 muted hues (see index.css). */
export const COLORS = [...CHART_SERIES_COLORS];

/** Geo charts — offset order so neighbors differ on small slices. */
export const COLORS_GEO = [
  CHART_SERIES_COLORS[2],
  CHART_SERIES_COLORS[4],
  CHART_SERIES_COLORS[6],
  CHART_SERIES_COLORS[1],
  CHART_SERIES_COLORS[8],
  CHART_SERIES_COLORS[3],
  CHART_SERIES_COLORS[5],
];
